import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-lifo-table',
    templateUrl: './lifo-table.component.html',
    styleUrls: ['./lifo-table.component.less'],
})
export class LifoTableComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
